export enum VotingStatus {
    Completed = "completed",
    InProgress = "in_progress",
    Planned = "planned",
    RequiresPlanning = "requires_planning",
    Cancelled = "cancelled"
}

export default VotingStatus
